import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { UserState } from './user.reducer';

export const getUserState: MemoizedSelector<Object, UserState> = createFeatureSelector<UserState>('user');
